import type { MenuItem } from "../menu.type";

import { SettingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { TAB_KEYS } from "@/constants/TabKeys";

export const useMenuItemNotificationSettings = (): MenuItem => {
  const { t } = useTranslation();
  return {
    key: "notification-settings-action",
    label: (
      <Link to={`/preferences?tab=${TAB_KEYS.PREFERENCES_NOTIFICATIONS}`}>
        {t("notification:settingsButton")}
      </Link>
    ),
    icon: <SettingOutlined />,
  };
};
